// The CFO view's own writes (CFO plan 5.2 / 5.1). Budgets themselves live in the books (saveBudget / deleteBudget,
// a callable); these are the two things kept here.
import { merge } from './writes.js';

const DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Date an undated billing stage: its milestone's targetDate (the books republish the forecast). null clears it. */
export function setMilestoneDate(ctx, { milestoneId, date }) {
  if (!milestoneId) throw new Error('setMilestoneDate: milestoneId required');
  if (date != null && !DATE.test(String(date))) throw new Error('setMilestoneDate: date is YYYY-MM-DD');
  const now = ctx?.now ?? Date.now();
  return { writes: [merge(`milestones/${milestoneId}`, { targetDate: date || null, updatedAt: now })] };
}

/** The billable hours planned a month — forward overhead per hour divides by it (yours, in meta/settings). */
export function setPlannedBillableHours(ctx, { hours }) {
  const h = hours == null || hours === '' ? null : Number(hours);
  if (h != null && !(h >= 0 && h <= 10000)) throw new Error('setPlannedBillableHours: hours 0–10000');
  const now = ctx?.now ?? Date.now();
  return { writes: [merge('meta/settings', { cfo: { plannedBillableHours: h }, updatedAt: now })] };
}
